import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import jwt_decode from 'jwt-decode';

const initialState = {
    token: { 'Count': 0 },
    status: 'idle',
    error: null,
};

export const storeToken = createAsyncThunk('user/storeToken', token => {
    return token;
});

const tokenSlice = createSlice({
    name: 'token',
    initialState,
    reducers: {
        incomingToken(state, action) {
            const { token } = action.payload;
            const currentToken = state.token;
            if (currentToken) {
                currentToken.token = token;
            }
        },
    },
    extraReducers: {
        [storeToken.pending]: (state, action) => {
            state.status = 'loading';
        },
        [storeToken.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            // Add any fetched posts to the array
            const tokenItems = jwt_decode(action.payload);
            delete tokenItems.iss;
            delete tokenItems.sub;
            delete tokenItems.aud;
            delete tokenItems.iat;
            delete tokenItems.exp;
            delete tokenItems.azp;
            tokenItems.Count = 1;
            state.token = tokenItems;
        },
    },
});

export const { incomingToken } = tokenSlice.actions;

export default tokenSlice.reducer;

export const getProfile = state => state.token;
